import Model from "./Model";
import IUser from "./interfaces/IUser";
import { Position } from "./Position";

export interface MeansType {
  name: string;
  icon: string;
  id: string;
}

export interface Type {
  name: string;
  id: string;
  um: string;
}

export class IsocronPosition {
  position!: Position;
}

export default class Isocron extends Model {
  static type = "isocrons";

  static meansTypes: Array<MeansType> = [
    { name: "In auto", id: "car", icon: "iso-car" },
    { name: "A piedi", id: "walk", icon: "iso-walk" },
    { name: "In bici", id: "bike", icon: "iso-bike" },
    { name: "In autobus", id: "truck", icon: "iso-bus" },
  ];

  static types: Array<Type> = [
    { name: "Distanza", id: "distance", um: "km" },
    { name: "Tempo", id: "duration", um: "min" },
  ];

  isocronType!: string;
  isocronMeansType!: string;
  isocronRange!: number;
  isocron!: IsocronPosition[];
  status!: string;

  get type() {
    return Isocron.types.find((o) => o.id === this.isocronType);
  }

  get meansType() {
    return Isocron.meansTypes.find((o) => o.id === this.isocronMeansType);
  }

  get isLoading() {
    return this.status === "pending";
  }

  get isCompleted() {
    return this.status === "completed";
  }

  get path() {
    return this.isocron.map((o) => o.position);
  }

  static path() {
    return [
      new Position(12.44923, 44.09353),
      new Position(12.452616, 44.091182),
      new Position(12.456003, 44.088833),
      new Position(12.459248, 44.086566),
      new Position(12.462566, 44.084326),
      new Position(12.46767, 44.082204),
      new Position(12.471943, 44.082363),
      new Position(12.475153, 44.072024),
      new Position(12.468962, 44.070252),
      new Position(12.467813, 44.07015),
      new Position(12.467317, 44.068346),
      new Position(12.467333, 44.067166),
      new Position(12.467368, 44.066729),
      new Position(12.468354, 44.0656),
      new Position(12.468871, 44.065563),
      new Position(12.472434, 44.064765),
      new Position(12.472521, 44.064753),
      new Position(12.47569, 44.06412),
      new Position(12.476488, 44.064156),
      new Position(12.477589, 44.064366),
      new Position(12.482974, 44.063363),
      new Position(12.483123, 44.06343),
      new Position(12.486009, 44.064123),
      new Position(12.489842, 44.063373),
      new Position(12.494388, 44.06287),
      new Position(12.496961, 44.061809),
      new Position(12.503748, 44.05929),
      new Position(12.506016, 44.053563),
      new Position(12.500585, 44.046753),
      new Position(12.493389, 44.048539),
      new Position(12.482995, 44.049819),
      new Position(12.47952, 44.048879),
      new Position(12.476041, 44.046644),
      new Position(12.475047, 44.046018),
      new Position(12.474181, 44.04554),
      new Position(12.474823, 44.043256),
      new Position(12.467263, 44.034851),
      new Position(12.464426, 44.034986),
      new Position(12.463768, 44.033835),
      new Position(12.462599, 44.031884),
      new Position(12.462149, 44.025866),
      new Position(12.462219, 44.025795),
      new Position(12.464116, 44.025344),
      new Position(12.473418, 44.026579),
      new Position(12.480106, 44.02465),
      new Position(12.481345, 44.024367),
      new Position(12.481896, 44.024229),
      new Position(12.482789, 44.024622),
      new Position(12.482838, 44.024655),
      new Position(12.490345, 44.031494),
      new Position(12.493979, 44.032542),
      new Position(12.50086, 44.036616),
      new Position(12.508812, 44.032347),
      new Position(12.507359, 44.025299),
      new Position(12.508042, 44.021764),
      new Position(12.50857, 44.021866),
      new Position(12.510291, 44.022533),
      new Position(12.511511, 44.023084),
      new Position(12.515106, 44.025595),
      new Position(12.517289, 44.026832),
      new Position(12.520907, 44.031535),
      new Position(12.52423, 44.032931),
      new Position(12.533211, 44.025463),
      new Position(12.529213, 44.015855),
      new Position(12.52927, 44.008788),
      new Position(12.520986, 44.005613),
      new Position(12.519815, 44.005905),
      new Position(12.514812, 44.005984),
      new Position(12.512672, 44.00548),
      new Position(12.510148, 43.996323),
      new Position(12.510131, 43.993847),
      new Position(12.51133, 43.990501),
      new Position(12.514694, 43.985402),
      new Position(12.514785, 43.985288),
      new Position(12.526017, 43.981292),
      new Position(12.526725, 43.980961),
      new Position(12.534311, 43.977194),
      new Position(12.535885, 43.977007),
      new Position(12.536013, 43.97706),
      new Position(12.537936, 43.978825),
      new Position(12.538021, 43.978977),
      new Position(12.544311, 43.986149),
      new Position(12.543341, 43.989616),
      new Position(12.549099, 43.99727),
      new Position(12.554217, 44.003563),
      new Position(12.56214, 43.998591),
      new Position(12.566007, 43.987256),
      new Position(12.565971, 43.985403),
      new Position(12.568848, 43.981876),
      new Position(12.570248, 43.981224),
      new Position(12.570317, 43.981214),
      new Position(12.572255, 43.982699),
      new Position(12.58078, 43.988309),
      new Position(12.58062, 43.991905),
      new Position(12.578535, 43.998499),
      new Position(12.580521, 44.004489),
      new Position(12.591047, 44.006084),
      new Position(12.594752, 43.998614),
      new Position(12.595911, 43.995206),
      new Position(12.600619, 43.992313),
      new Position(12.606273, 43.995204),
      new Position(12.618074, 43.994808),
      new Position(12.621023, 43.991589),
      new Position(12.624533, 43.989839),
      new Position(12.637306, 43.985824),
      new Position(12.64138, 43.983084),
      new Position(12.64844, 43.980287),
      new Position(12.652144, 43.978808),
      new Position(12.66219, 43.9727),
      new Position(12.667434, 43.968499),
      new Position(12.67444, 43.966991),
      new Position(12.685053, 43.965356),
      new Position(12.68595, 43.968842),
      new Position(12.683757, 43.969406),
      new Position(12.679219, 43.970005),
      new Position(12.6749, 43.970562),
      new Position(12.670291, 43.971259),
      new Position(12.662932, 43.977116),
      new Position(12.659071, 43.979769),
      new Position(12.653685, 43.982062),
      new Position(12.645472, 43.990129),
      new Position(12.642417, 43.992033),
      new Position(12.630795, 43.989218),
      new Position(12.62601, 43.993122),
      new Position(12.62263, 43.99481),
      new Position(12.611885, 44.000169),
      new Position(12.605671, 44.005824),
      new Position(12.60843, 44.017392),
      new Position(12.608447, 44.017454),
      new Position(12.614881, 44.026469),
      new Position(12.619383, 44.02547),
      new Position(12.624219, 44.020661),
      new Position(12.628532, 44.01655),
      new Position(12.629693, 44.014175),
      new Position(12.630946, 44.012878),
      new Position(12.631612, 44.012657),
      new Position(12.631813, 44.012694),
      new Position(12.637565, 44.014417),
      new Position(12.641781, 44.013897),
      new Position(12.64344, 44.013988),
      new Position(12.643596, 44.0141),
      new Position(12.643873, 44.016827),
      new Position(12.642848, 44.018008),
      new Position(12.642698, 44.018118),
      new Position(12.636195, 44.018509),
      new Position(12.629808, 44.024978),
      new Position(12.625965, 44.027939),
      new Position(12.621408, 44.03158),
      new Position(12.616081, 44.033829),
      new Position(12.609128, 44.039769),
      new Position(12.603034, 44.046952),
      new Position(12.599555, 44.050139),
      new Position(12.594735, 44.055774),
      new Position(12.591047, 44.059287),
      new Position(12.587372, 44.065293),
      new Position(12.578067, 44.071351),
      new Position(12.575405, 44.076918),
      new Position(12.568293, 44.074326),
      new Position(12.561301, 44.074921),
      new Position(12.551641, 44.078922),
      new Position(12.548721, 44.081101),
      new Position(12.544611, 44.083842),
      new Position(12.539381, 44.087374),
      new Position(12.532217, 44.089011),
      new Position(12.529302, 44.094207),
      new Position(12.524658, 44.099083),
      new Position(12.521613, 44.102272),
      new Position(12.521277, 44.102524),
      new Position(12.519994, 44.101986),
      new Position(12.518981, 44.101312),
      new Position(12.513036, 44.097235),
      new Position(12.502925, 44.098972),
      new Position(12.502257, 44.098482),
      new Position(12.501592, 44.097968),
      new Position(12.500366, 44.095419),
      new Position(12.502984, 44.091783),
      new Position(12.500506, 44.081487),
      new Position(12.500345, 44.081153),
      new Position(12.49053, 44.076739),
      new Position(12.486837, 44.079101),
      new Position(12.478643, 44.08201),
      new Position(12.470016, 44.08496),
      new Position(12.464534, 44.087341),
      new Position(12.461309, 44.089517),
      new Position(12.458055, 44.091792),
      new Position(12.454668, 44.09414),
      new Position(12.451281, 44.096489),
      new Position(12.44923, 44.09353),
    ].map((o) => {
      return { lat: o.lat, lng: o.lng };
    });
  }
}
